export default __webpack_public_path__ + "static/media/blindsGarageTop.decef1c3.gif";